/**
 * Money that arrives from the billing services in MINOR UNITS.
 *
 * 500 gbp is £5.00. It is never £500 (the minor unit read as a major one) and
 * never £0.05 (divided twice). Both mistakes render a plausible figure, which
 * is why the conversion lives in one place with tests on it rather than at
 * each call site.
 *
 * This was revenue-overview.tsx's private `formatMoney` until the promo codes
 * surface needed the same conversion for `amountOffMinorUnits`. It is lifted
 * here unchanged so the two surfaces cannot drift into two conventions.
 */
export function formatMinorUnits(minorUnits: number, currency: string): string {
  const code = (currency || "gbp").toUpperCase();
  try {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(minorUnits / 100);
  } catch {
    // An unrecognized code still has a real amount behind it. Showing the
    // number next to the raw code beats showing nothing.
    return `${(minorUnits / 100).toFixed(2)} ${code}`;
  }
}
